import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from './modulos/login/login';
import Index from './modulos/Index';
import Encuesta from './modulos/Encuesta/Encuesta';
import Mesas from './modulos/Mesas/Mesas';
import Reservas from './modulos/Reservas/Reservas';
import Restaurantes from './modulos/Restaurantes/Restaurantes';
 
import Cocinas from "./modulos/Cocinas/Cocinas";
import Comandas from "./modulos/Comandas/Comandas";
import Pagos from "./modulos/Pagos/Pagos";
import Usuarios from "./modulos/Usuarios/Usuarios";
import Proveedores from "./modulos/Proveedores/Proveedores";
import Clientes from "./modulos/Clientes/Clientes";
import Menu from "./modulos/Menu/Menu";
import ProtectedRoute from './modulos/Usuarios/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import NotFoundPage from "./modulos/dasboard/NotFoundPage";
import Logout from "./modulos/dasboard/Logout";
import Premios from "./modulos/Encuesta/Premios";
import HtmlEditor from "./modulos/HtmlEditor/HtmlEditor";
import RuletaPremios from "./modulos/Encuesta/RuletaPremios";
import PremioGanador from "./modulos/Encuesta/PremioGanador";
import Graficas from "./modulos/Graficas/Graficas";
import AccesoQr from "./modulos/AccesoQr/AccesoQr";
import GraficasPremios from "./modulos/Graficas/GraficasPremios";
import Ruleta from "./modulos/Encuesta/Ruleta";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="encuesta" element={<Encuesta />} />
          <Route path="login" element={<Login />} />
          <Route path="salir" element={<Logout />} />
          <Route path="qr" element={<AccesoQr />} />
          <Route path="premio_ganador" element={<PremioGanador />} />
          <Route path="ruleta" element={<Ruleta />} />
          <Route path="" element={<ProtectedRoute ><Index /></ProtectedRoute>} />
          <Route path="mesas" element={<ProtectedRoute ><Mesas /></ProtectedRoute>} />
          <Route path="premios" element={<ProtectedRoute ><Premios /></ProtectedRoute>} />
          <Route path="ganadores" element={<ProtectedRoute ><GraficasPremios /></ProtectedRoute>} />
          <Route path="graficas" element={<ProtectedRoute ><Graficas /></ProtectedRoute>} />
          <Route path="reservas" element={<ProtectedRoute ><Reservas /></ProtectedRoute>} />
          <Route path="restaurantes" element={<ProtectedRoute ><Restaurantes /></ProtectedRoute>} />
          <Route path="cocinas" element={<ProtectedRoute ><Cocinas /></ProtectedRoute>} />
          <Route path="comandas" element={<ProtectedRoute ><Comandas /></ProtectedRoute>} />
          <Route path="pagos" element={<ProtectedRoute ><Pagos /></ProtectedRoute>} />
          <Route path="usuarios" element={<ProtectedRoute ><Usuarios /></ProtectedRoute>} />
          <Route path="editor" element={<ProtectedRoute ><HtmlEditor /></ProtectedRoute>} />
          <Route path="ruleta" element={<ProtectedRoute ><RuletaPremios /></ProtectedRoute>} />
          <Route path="proveedores" element={<ProtectedRoute ><Proveedores /></ProtectedRoute>} />
          <Route path="clientes" element={<ProtectedRoute ><Clientes /></ProtectedRoute>} />
          <Route path="menu" element={<ProtectedRoute ><Menu /></ProtectedRoute>} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}



export default App;
